module.exports = __webpack_public_path__ + "img/cp.5f03d4b2.svg";